{
  "625": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "1254": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "2162": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "2560": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "2623": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "2884": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "2968": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "3197": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "3279": {
    "payors": ["buckeye"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "3281": {
    "payors": ["buckeye"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "3296": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "3379": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "3731": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "4050": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "4109": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "4517": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "4544": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "4659": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "4776": {
    "payors": ["buckeye"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "5005": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5300": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5333": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5343": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5365": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5456": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5463": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5506": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5525": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5591": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5639": {
    "payors": ["buckeye"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5700": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5702": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5744": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5773": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5774": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5797": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "5798": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6061": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6127": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6147": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6161": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6162": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6249": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6255": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6382": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6388": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6413": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6445": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6502": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6640": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6658": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6748": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6903": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "6976": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7191": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7230": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7244": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7263": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7311": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7343": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7654": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7744": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "7950": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "7976": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9080": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9136": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9346": {
    "payors": ["buckeye"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9560": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9588": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9817": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "9842": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "10366": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "10703": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "10767": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "10768": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "10910": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "11313": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "11473": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "11614": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "11706": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "11785": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "11990": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12023": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12406": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12442": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12460": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12529": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12792": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "12913": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "13812": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "13833": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "13834": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15078": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15330": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15397": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15593": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15594": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "15930": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "16034": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "17797": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "18175": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "18253": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "18277": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "19184": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "19361": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "19517": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "19708": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "19827": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "19860": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "19903": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "9am - 5:30pm",
      "tuesdayHours": "9am - 5:30pm",
      "wednesdayHours": "9am - 5:30pm",
      "thursdayHours": "9am - 5:30pm",
      "fridayHours": "9am - 5:30pm",
      "saturdayHours": "Closed"
    }
  },
  "19957": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "10am - 5pm",
      "mondayHours": "9am - 6pm",
      "tuesdayHours": "9am - 6pm",
      "wednesdayHours": "9am - 6pm",
      "thursdayHours": "9am - 6pm",
      "fridayHours": "9am - 6pm",
      "saturdayHours": "9am - 5pm"
    }
  },
  "59124": {
    "payors": ["bsc"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  },
  "111111": {
    "payors": ["braven", "clover", "horizon"],
    "hours": {
      "sundayHours": "Closed",
      "mondayHours": "11am - 7:30pm",
      "tuesdayHours": "11am - 7:30pm",
      "wednesdayHours": "11am - 7:30pm",
      "thursdayHours": "11am - 7:30pm",
      "fridayHours": "11am - 7:30pm",
      "saturdayHours": "Closed"
    }
  }
}
